/** @jsxImportSource @emotion/react */
import React from 'react'
import {UserForm, UserPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/UsersContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, users } = breadcrumbItems

const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, users]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <UserForm />
        </div>
        <div css={styles.right}>
          <UserPreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
